import React, { useState, useCallback } from 'react'

import { BrandBalance, DomainBalance } from '@/src/types/wallet'
import { DomainBalanceCarousel } from './domainBalanceCarousel'

interface DomainBalanceCarouselWrapperProps {
    displayBalance: number
    displayCurrency: string
    domainBalances: DomainBalance[]
    brandBalances: BrandBalance[]
    formatAmount: (amount: number, currency: string) => string
    t: (key: string, values?: Record<string, any>) => string
    isDesktop?: boolean
    attachBottom?: boolean
}

const DomainBalanceCarouselWrapper: React.FC<DomainBalanceCarouselWrapperProps> = ({
    displayBalance,
    displayCurrency,
    domainBalances,
    brandBalances,
    formatAmount,
    t,
    isDesktop,
    attachBottom
}) => {
    const [selectedDomainIndex, setSelectedDomainIndex] = useState(0)

    const handleDomainSelect = useCallback((index: number) => {
        setSelectedDomainIndex(index)
    }, [])

    const selectedDomain = domainBalances[selectedDomainIndex]
    const effectiveBalance = selectedDomain?.balance ?? displayBalance
    const effectiveCurrency = selectedDomain?.currency ?? displayCurrency

    return (
        <DomainBalanceCarousel
            displayBalance={effectiveBalance}
            displayCurrency={effectiveCurrency}
            domainBalances={domainBalances}
            brandBalances={brandBalances}
            selectedDomainIndex={selectedDomainIndex}
            onDomainSelect={handleDomainSelect}
            formatAmount={formatAmount}
            t={t}
            isDesktop={isDesktop}
            attachBottom={attachBottom}
        />
    )
}

export { DomainBalanceCarouselWrapper }
export default DomainBalanceCarouselWrapper
